import React from 'react';
import { ChaptersData } from './ChaptersData';
import { SwiperSlide } from 'swiper/react';
import ChapterWheelItem from './ChapterWheelItem';
import { KodanshaGeneralWheel } from './KodanshaGeneralWheel';

const KodanshaChaptersWheel = () => {
    return (
        <KodanshaGeneralWheel key={'custom-1'} discoverId={null}
                              chapter={true}
                              data={ChaptersData}
                              title={'Exclusive for Kodansha Readers! New chapters every Wednesday!'}
                              secondTitle={'KODANSHA READER PORTAL SERIES'}
                              preFetchedItems={null}
                              useCTA={false}
                              buttonUrl={'/series/blood-blade?showChapters=true'}
                              ctaText={'View All Chapters'}>

            {ChaptersData.slice(0,20).map((chapter, index) => {
                //console.log('ChaptersData', chapter);

                return <SwiperSlide key={chapter.id}>
                    <div aria-label={'main wheel'} className='ItemContainer'>
                        <ChapterWheelItem chapter={chapter} title={'Chapters'}
                                          cta={{ text: 'Read Chapter', id: 311 }} />
                    </div>

                </SwiperSlide>;
            })}
        </KodanshaGeneralWheel>
    );
};

export default KodanshaChaptersWheel;